var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainDiversityW150(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e40303",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 37.17)",
    d: "M148.37 147.45h713.25C770.28 56.34 644.22 0 505 0S239.72 56.34 148.37 147.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ff8c00",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 37.034)",
    d: "M861.33 147.16H148.67c-50.5 50.29-90.41 111.18-116.11 179.07h944.88c-25.7-67.89-65.61-128.78-116.11-179.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ffed00",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.887)",
    d: "M32.67 325.94C11.56 381.59 0 441.94 0 505h1010c0-63.06-11.56-123.41-32.67-179.06H32.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#008026",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.753)",
    d: "M1010 504.71H0v.29c0 62.95 11.52 123.2 32.56 178.77h944.88C998.48 628.2 1010 567.95 1010 505v-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#004dff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.607)",
    d: "M977.55 683.48H32.45c25.65 67.87 65.5 128.77 115.92 179.06h713.25c50.43-50.29 90.28-111.19 115.93-179.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#750787",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.472)",
    d: "M861.92 862.25H148.08C239.45 953.54 365.63 1010 505 1010s265.55-56.46 356.92-147.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#1d1d1b",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.926 36.82)",
    d: "M301.9 42.51C124.13 120.69 0 298.35 0 505c0 202.94 119.71 377.92 292.36 458.18l466.89-457.3L301.9 42.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#613915",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.975 36.826)",
    d: "M218.5 89.09C86.51 180.18 0 332.49 0 505c0 170.14 84.14 320.63 213.09 412.13l415.53-411.58L218.5 89.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#74d7ee",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 37.024 36.818)",
    d: "M143.09 152.8C54.54 243.78 0 368.02 0 505c0 137.03 54.58 261.31 143.18 352.29l357.15-351.74L143.09 152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#ffafc8",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 37.081 36.817)",
    d: "M83.78 226.35C30.84 306.21 0 402 0 505c0 101.34 29.86 195.7 81.25 274.79l271.9-274.28L83.78 226.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 37.14 36.816)",
    d: "M35.79 317.92C12.71 375.78 0 438.9 0 505c0 66.54 12.88 130.07 36.26 188.24l186.68-186.8L35.79 317.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.822)",
    d: "M247.77 505c0-142.06 115.16-257.23 257.24-257.23 142.06 0 257.23 115.17 257.23 257.23S647.07 762.24 505.01 762.24C362.92 762.23 247.77 647.06 247.77 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#4c9046",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.822 36.822)",
    d: "M505 756.8c-67.26 0-130.5-26.19-178.06-73.75-47.55-47.56-73.74-110.8-73.74-178.05 0-67.26 26.19-130.49 73.75-178.05S437.74 253.2 505 253.2s130.49 26.19 178.05 73.75S756.8 437.74 756.8 505s-26.19 130.49-73.75 178.05S572.26 756.8 505 756.8zM361.18 644.15c35.55 31.35 98.16 54.04 149.4 54.04 43.98 0 84.09-14.8 112.94-41.66 25.35-23.6 40.48-55.54 40.48-85.44 0-81.35-69.67-97.55-131.13-111.84-48.04-11.17-93.42-21.72-93.42-63.13 0-20.28 17.65-42.11 56.4-42.11 28.69 0 57.09 7.13 84.41 21.18 21.56 11.09 42.22 26.53 60.09 44.87v-57.58c-40.84-31.34-90.32-47.9-143.16-47.9-34.37 0-68.79 10.79-94.45 29.62-20.38 14.95-44.67 41.9-44.67 85.4 0 80.79 69.62 99.25 131.04 115.53 23.53 6.24 45.76 12.13 62.19 21.11 18.67 10.21 27.74 23.62 27.74 41.02 0 11.64-7.42 23.3-20.36 32.01-13.11 8.82-30.19 13.68-48.09 13.68-29 0-59.18-8.38-87.28-24.25-24.17-13.64-45.99-32.59-62.12-53.84v69.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: "matrix(.08 0 0 .08 36.81 36.822)",
    d: "M505 255.59c137.74 0 249.41 111.67 249.41 249.41 0 137.75-111.67 249.42-249.41 249.42-137.76 0-249.42-111.67-249.42-249.42.01-137.75 111.66-249.41 249.42-249.41m5.58 394.97c-59.82 0-119.2-36.15-151.78-83.04v77.7c34.37 30.79 97.31 55.35 151.78 55.35 97.77 0 155.8-69.64 155.8-129.49 0-148.19-224.56-84.8-224.56-174.97 0-21.43 19.64-39.73 54.01-39.73 60.72 0 112.51 32.57 146.88 69.64v-64.73C603 330.49 553 312.18 497.19 312.18c-66.96 0-141.51 41.07-141.51 117.41 0 145.53 220.97 93.31 220.97 177.66 0 22.34-29.46 43.31-66.07 43.31M505 250.81c-34.32 0-67.61 6.72-98.95 19.98-30.27 12.8-57.45 31.13-80.8 54.47-23.34 23.34-41.67 50.52-54.47 80.79-13.25 31.34-19.98 64.63-19.98 98.94s6.72 67.6 19.98 98.94c12.8 30.27 31.13 57.45 54.47 80.8 23.34 23.34 50.53 41.67 80.79 54.47 31.34 13.26 64.63 19.98 98.95 19.98 34.31 0 67.6-6.72 98.94-19.98 30.27-12.8 57.45-31.13 80.79-54.47 23.34-23.34 41.67-50.53 54.47-80.8 13.26-31.34 19.98-64.63 19.98-98.94s-6.72-67.6-19.98-98.94c-12.8-30.27-31.13-57.45-54.47-80.79-23.34-23.34-50.53-41.67-80.79-54.47-31.33-13.25-64.61-19.98-98.93-19.98zm5.58 404.52c18.37 0 35.92-5 49.43-14.09 13.61-9.16 21.41-21.55 21.41-33.99 0-18.35-9.48-32.45-28.98-43.11-16.69-9.12-39.05-15.05-62.73-21.33-31.08-8.24-63.22-16.76-88.06-33.4-13.2-8.85-22.92-19.04-29.71-31.17-7.73-13.8-11.48-29.71-11.48-48.64 0-42.51 23.76-68.86 43.7-83.48 25.26-18.53 59.17-29.15 93.04-29.15 51.91 0 100.54 16.14 140.77 46.69v50.63c-17.08-16.72-36.46-30.85-56.61-41.22-27.66-14.23-56.43-21.45-85.5-21.45-17.36 0-32.18 4.44-42.85 12.85-10.27 8.1-15.93 19.33-15.93 31.65 0 43.31 46.28 54.06 95.27 65.45 31.22 7.26 63.5 14.76 88.29 30.65 13.15 8.42 22.82 18.33 29.57 30.29 7.69 13.61 11.43 29.5 11.43 48.58 0 14.19-3.51 29.22-10.15 43.46-6.84 14.68-17.07 28.59-29.57 40.23-13.55 12.62-29.52 22.55-47.45 29.53-19.6 7.63-41.09 11.49-63.86 11.49-50.33 0-111.72-22.09-147.01-52.73v-61.3c15.83 19.4 35.84 36.18 58.56 49.01 28.43 16.06 59.01 24.55 88.42 24.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainDiversityW150);
export default __webpack_public_path__ + "static/media/train-diversity-w150.491f0dba99b1d2aad8a63aefbd322433.svg";
export { ForwardRef as ReactComponent };